import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "maximize",
  "use": "maximize-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"maximize\"><path d=\"M229.231 282.769a24 24 0 0 1 0 33.94L81.941 464h116a24 24 0 0 1 0 48H24a24 24 0 0 1-24-24V314.056a24 24 0 0 1 48 0v116l147.29-147.29a24 24 0 0 1 33.941.003zm275.74-275.74A24 24 0 0 0 488 0H314.055a24 24 0 0 0 0 48h116L282.769 195.29a24 24 0 0 0 33.94 33.941L464 81.941v116a24 24 0 0 0 48 0V24a24 24 0 0 0-7.029-16.971z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol